import {
  List,
  Datagrid,
  ReferenceField,
  ChipField,
  TextField,
  DateField,
  EmailField,
  ImageField,
  NumberField,
  ArrayField,
  BooleanField,
  ReferenceInput,
  BooleanInput,
  TextInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserProfileList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <ReferenceInput key="filter-groupId" source="groupId" reference="groups" />,
      <BooleanInput key="filter-isEmailNotificationsOn" source="isEmailNotificationsOn" />,
      <BooleanInput key="filter-isPushNotificationsOn" source="isPushNotificationsOn" />,
      <TextInput key="filter-status" source="status" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ReferenceField source="groupId" reference="groups" />
      <ReferenceField source="userId" reference="users" />
      <ChipField source="language" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <DateField source="birthDate" />
      <TextField source="telegramUsername" />
      <ReferenceField source="telegramId" reference="telegrams" />
      <EmailField source="email" />
      <TextField source="phoneNumber" />
      <ImageField source="avatarUrl" title="avatarUrl" />
      <NumberField source="utcOffset" />
      <ArrayField source="deviceTokens">
        <Datagrid>
          <ChipField source="type" />
          <TextField source="token" />
        </Datagrid>
      </ArrayField>
      <BooleanField source="isEmailNotificationsOn" />
      <BooleanField source="isPushNotificationsOn" />
      <TextField source="respondedBy" />
    </Datagrid>
  </List>
)

export const UserProfileShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="groupId" reference="groups" />
      <ReferenceField source="userId" reference="users" />
      <ChipField source="language" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <DateField source="birthDate" />
      <TextField source="telegramUsername" />
      <ReferenceField source="telegramId" reference="telegrams" />
      <EmailField source="email" />
      <TextField source="phoneNumber" />
      <ImageField source="avatarUrl" title="avatarUrl" />
      <NumberField source="utcOffset" />
      <ArrayField source="deviceTokens">
        <Datagrid>
          <ChipField source="type" />
          <TextField source="token" />
        </Datagrid>
      </ArrayField>
      <BooleanField source="isEmailNotificationsOn" />
      <BooleanField source="isPushNotificationsOn" />
      <TextField source="respondedBy" />
    </SimpleShowLayout>
  </Show>
)
